import React from 'react';
import cn from 'classnames';
import Wrap from 'components/about/wrap';
import style from 'styles/about/about.module.scss';
const introduce = [
  '小鱼易连——云视频国家队，荣获中国电子等数家国资企业的战略投资赋能，并作为信创工委会成员单位，以安全可信的自主技术，打造“高安全·超融合·全连接”云视频，为政府、政法、金融、教育、医疗等行业及企业用户提供数字化服务，助力数字中国战略落地。',
  '自2014年成立以来，小鱼易连持续坚持技术创新，在北京、深圳、西安、武汉、成都、郑州设有六大研究院，并在全国各地部署诸多运营机构。对自主核心技术的深入研究和投入，令小鱼易连全面掌握核心自主知识产权，已拥有百余项云视频专利技术与软件著作权，并在业内创新推出“超融合视频平台+全连接视频终端+泛业务开发底座”综合方案，全面推动各行各业数字化升级。',
  '多年行业深耕，小鱼易连已深入到政务、政法、教育、保险、银行、医疗、制造、石油、电力、建筑、高科技电子等领域，服务超过16万家大中型客户，包括50多家国家部委和中央企业，以及300多家省市政府机构，建设运营了超大规模的政务云视频服务平台。根据IDC《中国视频会议与协作市场跟踪报告（2019年、2020年和2021年）》，小鱼易连蝉联中国网络会议市场占有率第一。',
  '同时，在工信部电子信息司和信息技术发展司指导下，中国电子技术标准化研究院联合小鱼易连、国家信息中心等发布了云视频首个行业白皮书——《云视频关键技术及标准化白皮书》，共同制定云视频行业技术标准、推动产业发展。',
  '秉承“建设有核心自主知识产权的高科技民族企业”的使命，小鱼易连将一如既往以“为客户创造价值”为第一驱动力，并携手广大战略合作伙伴一起，用科技振兴民族，让世界零距离。',
];
const honor = [
  {
    prize: 'https://sdk-source.xylink.com/website/assets/home/2025_M.png',
    year: '2025',
    items: [
      '⁠IDC 中国私有云会议市场占有率第一（2025H1）',
      '全国数字政府标准案例50强',
      '2025年信创卓越领导力企业',
      '2025数字政府创新成果与实践案例-方案案例创新类',
      '2025北京大学平民学校贡献奖',
      '鸿蒙商用市场"先行奖"',
      '智慧军工数智化实践典型案例"创新突破"类',
    ],
  },
  {
    prize: 'https://sdk-source.xylink.com/website/assets/home/2024_2_M.png',
    year: '2024',
    items: [
      'IDC 中国私有云会议市场占有率第一',
      '全国数字政府标准案例50强',
      '入选中国信通院《高质量数字化转型技术解决方案》',
      '2024数字政府创新成果与实践案例-方案案例创新类',
      '2024中国信创百强榜',
      '2024能源企业信息化方案案例创新类',
      '2024国有企业数智化转型样板案例',
      '金数奖-2024年度CIO最信赖数字化伙伴',
    ],
  },
  {
    prize: 'https://sdk-source.xylink.com/website/assets/home/honor2023M.png',
    year: '2023',
    items: [
      'IDC 中国私有云会议市场占有率第一',
      '上海市科技小巨人企业',
      '2023胡润全球未来独角兽',
      '2023中国隐形独角兽500强（位列前100名）',
      '入选中国信通院《高质量数字化转型产品\n及服务全景图》',
      '数字中国典型方案与实践案例-年度优秀解决\n方案',
      '应急管理信息化产品技术创新奖',
      '金政奖-数字政务优秀解决方案',
      '优秀数字化解决方案提供商',
      '中国信创产业优秀厂商',
      '数字化转型突出贡献企业奖',
      '信创创新产品奖',
      '年度前沿科技产品-最佳技术突破奖',
      '2023信创产业TOP100榜单',
      '信息技术应用创新推荐解决方案',
      'iTECH 2023年度创新企业',
    ],
  },
  {
    prize: 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/about/2de5ed54e606fd051a7a89c49c4da5e0cd4fea6e03bb9a7ece8150b58dafa11a.png',
    year: '2022',
    items: [
      'IDC 中国私有云会议市场占有率第一',
      '2022数字政府创新方案提供商',
      '2022年度优秀数字化解决方案提供商',
      '2021年度信息技术应用创新典型解决方案',
      '2022云视频行业领航企业',
      '信创产业十大赛道先锋力量-云视频创新奖',
      '中国信息自主潜在独角兽企业',
      '中国信创厂商精选60强',
      '数字企业卓越服务商',
      '2022创新场景50-最佳云视频场景实践奖',
    ],
  },
  {
    prize: 'https://testdevcdn.xylink.com/h5/sdk_doc/static/website/02d6d7f5b0a351faed1c01bf3db17efd2ffec3084ae075ead6fea10c3f0e643b.png',
    year: '2021',
    items: [
      'IDC 中国网络会议市场占有率第一',
      '2021年度中国企业服务产业最佳投资案例TOP10',
      '2021投中榜·锐公司100榜单',
      '2021科技创新引领奖',
      '智慧司法创新方案奖',
      '数字政府最佳实践奖',
      '优秀数字化解决方案提供商',
      '数字新经济·云视频领域领军企业',
      '数字新基建·云视频解决方案首选服务商',
      '数字新经济·企业数字化转型最具影响力企业',
      '数字新基建·最佳政务云视频解决方案奖',
      '智慧高校解决方案创新奖',
    ],
  },
  {
    prize: 'https://devcdn.xylink.com/xylink_website_doc/images/about/about-us/m/glory-2020.png',
    year: '2020',
    items: [
      'IDC 中国网络会议市场占有率第一',
      '新基建产业独角兽',
      '中国科创企业百强榜',
      '最佳协同办公解决方案奖',
      '发布云视频首个行业白皮书',
      '中国软件技术领军企业',
      '全国数字生态优秀应用案例',
      '最具竞争力企业、最具影响力企业',
    ],
  },
  {
    prize: 'https://devcdn.xylink.com/xylink_website_doc/images/about/about-us/m/glory-2019.png',
    year: '2019',
    items: [
      'IDC 中国网络会议市场占有率第一',
      '真榜·2018中国互联网“逆生长”准独角兽公司TOP50',
      'Gartner 2019 Cool Vendors',
      '智慧司法优秀解决方案奖',
      '智慧会议系统标准工作组成员单位',
      '36Kr WISE 2019新商业引领者100榜',
      '中国企业家 中国科创企业百强榜',
      '嘉宾大学&人民日报数字版 2019科创榜POWER100榜',
      'GNTC IPv6先锋企业',
      '中国现代办公设备协会 优秀制造厂商',
      '36kr 新经济之王·企业服务应用服务之王',
      'i黑马 企业通用服务独角兽',
      '创业邦 2019中国创新成长企业100强',
      '创业邦 卓业企业应用提供商TOP 5',
      '钛媒体 年度企业社会责任先锋',
      '慧聪网 十大音视频品牌',
      '极客公园 社会效率推动力榜单',
      '2019年度企业级会议协作系统星标大奖',
    ],
  },
  {
    prize: '/v2/images/about/mobile/4.png',
    year: '2018',
    items: [
      '全国政法智慧司法十大解决方案提供商',
      '2018年度CIO 最信赖服务商奖',
      '中国教育行业发展论坛 2018优秀品牌奖',
      'GET2018碰撞演变 GET荣誉嘉宾',
      '36Kr新经济之王 企业服务最具影响力奖',
      '创业邦 中国企业服务创新成长50强',
      '猎云网 最佳企业服务商',
      'i黑马2018 企业服务产业独角兽',
      '钛媒体 年度CSR先锋',
      '品途NBI Awards商业影响力 年度企业服务奖',
      '品途NBI Awards商业影响力 年度人物',
    ],
  },
  {
    prize: '/v2/images/about/mobile/1.png',
    year: '2017',
    items: [
      '赛迪集团 2017 云视频会议行业领军企业',
      '赛迪集团 2017 云视频会议行业领军人物',
      '2017 创业邦 100-中国创新成长企业 100 强',
      'CIO 时代最信赖供应商奖',
      'CIO 时代大数据人物奖',
      '钛媒体 2017 年度前沿科技产品奖',
      '36Kr 年度最具影响力企业服务 TOP 奖',
      '中关村在线2017 年度推荐产品大奖',
    ],
  },
  {
    prize: '/v2/images/about/mobile/2.png',
    year: '2016',
    items: ['入选中关村创业大街 “创新先锋 2016”榜单', '2016 未来医疗 100 强', '正和岛亿+计划入围产品', '中国联通优秀贡献奖', '2016 中国视频应用产品创新奖', 'T100 新技术新产品创新力行动奖'],
  },
  {
    prize: '/v2/images/about/mobile/3.png',
    year: '2015',
    items: [
      '中国现代办公设备协会推荐创新产品奖',
      '2015 中国年度创新成长企业 100 强',
      '中关村新技术新产品证书',
      '德勤中关村明日之星',
      '第四届中国国际消费电子 Leader 工业设计奖',
      '第四届全国创新创业大赛北京赛区一等奖',
      '第四届中国国际消费电子 Leader 创新奖',
      '海帆企业证书',
      '第十七届高交会优秀成果奖',
      '中关村高新技术企业证书',
      '中国最具投资价值企业 60 强',
      '国家高新技术企业证书',
    ],
  },
];
const About = () => {
  return (
    <Wrap title="关于我们" pageKey="about">
      <div className={style.introduce}>
        <div className={style.title}>公司介绍</div>
        <div className={style.desc}>
          {introduce.map((item: string, index: number) => {
            return <div key={index}>{item}</div>;
          })}
        </div>
        <div id="honer"></div>
      </div>
      <div className={style.honor}>
        <div className={style.title}>公司荣誉</div>
        <img src="https://testdevcdn.xylink.com/h5/sdk_doc/static/website/81f680c07ebc7bc861febe06dcf280a6f167d07bfd4da5de542cb1f68796ebb1.jpg" alt="公司荣誉" className={cn(style.banner, 'for-pc')} />
        <div className={style.glory}>
          {honor.map(item => {
            return (
              <div key={item.prize} className={style['glory-item']}>
                <img src={item.prize} className={cn('for-mobile')} alt="" />
                <div className={style['glory-year']}>
                  <div className={cn(style['year'])}>{item.year}</div>
                </div>
                <div className={style.row}>
                  {item.items.map((d, idx: number) =>
                    item.year === '2023' && (idx === 4 || idx === 5) ? <div dangerouslySetInnerHTML={{ __html: `${d}`.replace(/\n/g, '<br/>') }}></div> : <div key={d}>{d}</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Wrap>
  );
};

export default About;
